module.exports = __webpack_public_path__ + "d7e356b6e9683fbbae0f51b327a89705.svg";